import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-common-strings';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { observer } from 'mobx-react';
import { signout } from '../actions/signout';
var styles = require('./HeaderPane.scss');
var ConsumerLiveEditProfilePageLink = 'https://account.microsoft.com/profile';
var ConsumerLiveAccountSettingsPageLink = 'https://account.microsoft.com';
var MeCardPane = /** @class */ (function (_super) {
    tslib_1.__extends(MeCardPane, _super);
    function MeCardPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEditProfileClicked = function () {
            window.open(ConsumerLiveEditProfilePageLink, '_blank');
        };
        _this.onViewAccountClicked = function () {
            window.open(ConsumerLiveAccountSettingsPageLink, '_blank');
        };
        _this.onSignoutClicked = function () {
            signout(location);
        };
        return _this;
    }
    MeCardPane.prototype.componentWillUnmount = function () {
        this.props.onDismiss();
    };
    MeCardPane.prototype.render = function () {
        var userConfiguration = getUserConfiguration();
        return (React.createElement(HeaderFlexPane, { title: function () { return strings.myAccount; }, onDismiss: this.props.onDismiss, content: React.createElement("div", null,
                React.createElement(PersonaControl, { name: userConfiguration.SessionSettings.UserDisplayName, emailAddress: userConfiguration.SessionSettings.UserEmailAddress, size: PersonaSize.small, showPersonaDetails: true, hexConsumerIdForUser: userConfiguration.HexCID, className: styles.persona }),
                React.createElement("ul", { className: styles.actions },
                    React.createElement("li", null,
                        React.createElement(CommandButton, { onClick: this.onEditProfileClicked, text: strings.editProfile, className: styles.action })),
                    React.createElement("li", null,
                        React.createElement(CommandButton, { onClick: this.onViewAccountClicked, text: strings.viewAccount, className: styles.action })),
                    React.createElement("li", null,
                        React.createElement(CommandButton, { onClick: this.onSignoutClicked, text: strings.signOut, className: styles.action })))) }));
    };
    MeCardPane = tslib_1.__decorate([
        observer
    ], MeCardPane);
    return MeCardPane;
}(React.Component));
export default MeCardPane;
//# sourceMappingURL=MeCardPane.js.map